import { render, staticRenderFns } from "./GamesNavMenu.vue?vue&type=template&id=4a488e15"
import script from "./GamesNavMenu.vue?vue&type=script&lang=js"
export * from "./GamesNavMenu.vue?vue&type=script&lang=js"
import style0 from "./GamesNavMenu.vue?vue&type=style&index=0&id=4a488e15&prod&lang=scss"
import style1 from "./GamesNavMenu.vue?vue&type=style&index=1&id=4a488e15&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports